import { ChatAttachmentPayload, PendingAttachment } from "../../../types/chat";

export const SUPPORTED_ATTACHMENT_MIME_TYPES: Record<string, string> = {
    "application/pdf": "PDF",
    "text/csv": "CSV",
    "application/vnd.ms-excel": "XLS",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
    "application/msword": "DOC",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
};

export const MAX_ATTACHMENT_BYTES = 4_500_000;
export const MAX_ATTACHMENTS_PER_MESSAGE = 5;

export const ATTACHMENT_FILE_INPUT_ACCEPT = [
    ...Object.keys(SUPPORTED_ATTACHMENT_MIME_TYPES),
    ...Object.values(SUPPORTED_ATTACHMENT_MIME_TYPES).map((ext) => `.${ext.toLowerCase()}`),
].join(",");

export function validateAttachmentFile(file: File): string | null {
    if (!(file.type in SUPPORTED_ATTACHMENT_MIME_TYPES)) {
        return `Tipo de arquivo não suportado: ${file.name}`;
    }
    if (file.size > MAX_ATTACHMENT_BYTES) {
        const maxMb = (MAX_ATTACHMENT_BYTES / 1_000_000).toFixed(1).replace(".", ",");
        return `Arquivo muito grande (máx. ${maxMb}MB): ${file.name}`;
    }
    return null;
}

function readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result as string;
            resolve(result.slice(result.indexOf(",") + 1));
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
}

export async function fileToPendingAttachment(file: File): Promise<PendingAttachment> {
    const data_base64 = await readFileAsBase64(file);
    const payload: ChatAttachmentPayload = {
        filename: file.name,
        mime_type: file.type,
        data_base64,
    };
    return {
        id: `attachment-${Date.now()}-${Math.random()}`,
        filename: file.name,
        sizeBytes: file.size,
        payload,
    };
}
